<div class="container container--pricing-table mt-5 mb-5">
  <div class="row mb-5">
    <div
      class="col-12 d-inline-block d-flex flex-column choose-plan-title-wrapper"
    >
      <span class="choose-plan-title text-center">{{ membershipSelectionTitle }}</span>
    </div>
  </div>
  <div class="row mb-3 mt-5">
    <div class="col-12">
      <app-pricing-table
        *ngIf="!isAuthenticated || (isAuthenticated && user && !isIdentiSmartTagPlanAvailable)"
        [userCurrentProductType]="userCurrentProductType"
        [hidePrices]="true"
        [showShortDescription]="false"
        [showFeatures]="true"
        [pricingPlans]="pricingPlans"
        [showWideIdentiAlertCard]="true"
        [user]="user"
        [buttonLabel]="'Learn more'"
        (onSelect)="select($event)"
        (onNavigateToProductPage)="navigateToProductPage($event)"
        [hasBuyNow]="true"
        [hideIcons]="true"
        [appPriceCardFeatureText]="plan1Benefits"
        [showPeachBanner]="true"
      ></app-pricing-table>
    </div>
    <div class="col-12">
      <app-fixed-pricing-table
        *ngIf="!isAuthenticated || (isAuthenticated && user && isIdentiSmartTagPlanAvailable)"
        [viewOnly]="true"
        [showShortDescription]="true"
        [buttonLabel]="'Learn more'"
        [pricingPlans]="pricingPlans"
        [hidePrices]="true"
        (onSelect)="select($event)"
        [showWideIdentiAlertCard]="true"
        [showDescriptionList]="true"
        [hideIcons]="true"
        [hasBuyNow]="true"
        [appPriceCardFeatureText]="plan1Benefits"
        [showPeachBanner]="true"
        [user]="user"
      >
      </app-fixed-pricing-table>
    </div>
  </div>
</div>
